
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    //@Serenity.Decorators.panel()
    export class ContraDialog extends _Ext.DialogBase<ContraRow, any> {
        protected getFormKey() { return ContraForm.formKey; }
        protected getIdProperty() { return ContraRow.idProperty; }
        protected getLocalTextPrefix() { return ContraRow.localTextPrefix; }
        protected getNameProperty() { return ContraRow.nameProperty; }
        protected getService() { return ContraService.baseUrl; }
        protected getDeletePermission() { return ContraRow.deletePermission; }
        protected getInsertPermission() { return ContraRow.insertPermission; }
        protected getUpdatePermission() { return ContraRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        public form = new ContraForm(this.idPrefix);
        public knockoffvalue;

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 300;
            q.initDetailEditor(this, this.form.Details, Config);
            q.hideEditorTab(this.form.Details);
            q.hideCaption(this.form.LedgerName);
            q.setTextRightAlign(this.form.TotalAmount);


            //this.form.CurrencyId.changeSelect2(e => {
            //    //set Exchange Rate feild of Detail Grid Dialog
            //    var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
            //    this.form.Details.exchangerate = exchangerate[0].ExchRate;
            //    //new ContraDetaildialog().exchangerate = 1;
            //    Q.Authorization.userDefinition.exchangerate = exchangerate[0].ExchRate;
            //});
            (this.form.Details.view as any).onDataChanged.subscribe(() => {
                //set Total Amount on Payment Grid Change

                var amt = 0;
                for (var k of this.form.Details.getItems()) {
                    amt += k.Amount;
                }
                this.form.TotalAmount.value = amt;
            });
            (this.form.Details.view as any).onRowCountChanged.subscribe(() => {
                //set Total Amount on Payment Grid Change

                if (this.form != undefined) {
                    var amt = 0;
                    for (var k of this.form.Details.getItems()) {
                        amt += k.Amount;
                    }
                    this.form.TotalAmount.value = amt;
                    if (this.form.Details.getElement().length > 0) {
                        q.hideEditorToolbar(this.form.Details);
                    }
                }

            });

            this.validateForm();
        }
       
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.LedgerId.value == "") {
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.ExchangeRate.value = exchangerate[0].ExchRate;
            }
            if (parseInt(this.form.LedgerId.value) == null) {
                //set Default Values based on Login
                this.form.EnteredBy.value = Q.Authorization.userDefinition.Username;
                Serenity.EditorUtils.setReadOnly(this.form.EnteredBy, true);
                this.form.UserId.value = Q.Authorization.userDefinition.UserId;
                this.form.CurrencyId.value = Q.Authorization.userDefinition.CurrencyId.toString();
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.Details.exchangerate = exchangerate[0].ExchRate;
                //new ContraDetaildialog().exchangerate = 1;
                Q.Authorization.userDefinition.exchangerate = exchangerate[0].ExchRate;
            }
            var fieldEditor: JQuery = this.form.LedgerId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }
        protected inplaceSearchClick(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                if (this.form.Details.getItems().length == 0) {
                    var grid = Common.PartySelectGrid;
                    var filters: _Ext.SelectGridFilters = {
                        AccountGroupId: 38
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Party", GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: OMS.CustomerRow[]) => {

                        if (selectedItems.length > 0) {

                            this.form.LedgerId.value = selectedItems[0].LedgerId.toString();
                            this.form.LedgerName.value = selectedItems[0].LedgerName;
                        }
                    }
                    pickerDialog.dialogOpen();
                }
                else
                    q.Alert("Not Allowed", "Party can not be changed while items are added", 2000, false);
            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            var buttons = super.getToolbarButtons();

            var btnDelete = Q.first(buttons, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            //Report Generation Button
            buttons.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Finance.Payment',
                getParams: () => ({
                    PaymentID: this.get_entityId()
                })
            }));
            return buttons;
        }

        protected updateTitle() {

            //get Back Button on the Dialog
            this.dialogTitle = "Payment Voucher";
        }

        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            //if (this.canDelete) {
            //    ContraService.Delete(
            //        {

            //            EntityId: this.entityId
            //        }, response => {
            //            Serenity.SubDialogHelper.triggerDataChange(self);
            //            self.dialogClose();
            //            window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
            //        });
            //} else {
            //    Q.alert("Further Payments for the Vouchers have been made, Cannot delete");
            //    return;
            //}

        }
    }




}
